import { atom } from 'jotai';

export const authStateAtom = atom<'unknown' | 'authorized' | 'unauthorized'>('unknown');
